<template>
  <div class="m-item text-xs-center subheading">
    <div v-if="enabled" style="min-height: 160px">
      <p class="font-weight-medium active mb-3">This Week</p>
      <router-link :to="{path: route}">
        <img :src="icon" width="100" height="100">
      </router-link>
      <p class="font-weight-medium active">{{name}}</p>
    </div>
    <div v-if="!enabled" style="min-height: 160px">
      <p class="font-weight-medium secondary--text mb-3" v-if="nextUp">Next Week</p>
      <p class="font-weight-medium mb-3" v-else>&nbsp;</p>
      <img :src="icon" width="100" height="100">
      <p class="font-weight-medium">{{name}}</p>
    </div>
  </div>
  
</template>

<script>
import {find} from 'lodash'
import manips from '@/data/manips.js'
const manipsURI = 'manipulatives/'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    nextUp: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      route: '',
      icon: '',
      name: ''
    }
  },
  mounted: function () {
    this.config = find(manips, {'id': this.id});

    this.route = manipsURI + this.config.id;
    this.icon = this.config.iconFileName;
    this.name = this.config.displayName;
  }
}
</script>

<style scoped>
.icon {
  cursor: pointer;
}

a {
  color: #000000;
}

.active {
  color: white;
  font-size: 18px;
}
</style>
